import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { WarrantyStats } from "@shared/modules/x-garanties";
import { Card } from "../../../core/components/ui/card";
import { getStats } from "../lib/api";

/** Accueil : garanties émises ce mois-ci et signatures en attente. */
export function GarantiesWidget() {
  const [stats, setStats] = useState<WarrantyStats | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    getStats()
      .then((s) => {
        setStats(s);
        setFailed(false);
      })
      .catch(() => setFailed(true));
  }, []);

  return (
    <Card
      title="Garanties"
      subtitle="Antirouille 10 ans"
      actions={<Link to="/garanties">Voir les garanties</Link>}
    >
      {failed ? (
        <p className="garanties-widget__empty">Chiffres indisponibles pour l'instant.</p>
      ) : (
        <dl className="garanties-widget__stats">
          <div className="garanties-widget__stat">
            <dt className="garanties-widget__label">Émises ce mois-ci</dt>
            <dd className="garanties-widget__value">{stats ? stats.emittedThisMonth : "—"}</dd>
          </div>
          <div className="garanties-widget__stat">
            <dt className="garanties-widget__label">Signatures en attente</dt>
            <dd className="garanties-widget__value">{stats ? stats.pendingSignature : "—"}</dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
